// Shared header for authed pages: brand lockup (home), an admin-only Public/Admin
// switch (Messy only), and a profile chip that opens the profile sheet (PRD §3.12).

import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { Avatar } from "./Avatar";
import { ProfileSheet } from "./ProfileSheet";
import { PwaInstallPrompt } from "./PwaInstallPrompt";

export function AppHeader() {
  const { user, isAdminView, setPreviewPublic } = useAuth();
  const navigate = useNavigate();
  const [profileOpen, setProfileOpen] = useState(false);
  if (!user) return null;

  const isAdmin = user.role === "admin";

  return (
    <>
      <header className="sticky top-0 z-20 border-b-2 border-ink/10 bg-white">
        <div className="mx-auto flex w-full max-w-xl items-center justify-between gap-2 px-4 py-3">
          <Link to="/" className="flex min-w-0 items-center gap-2.5" aria-label="Citrus-Dala home">
            <img
              src="/logo.png"
              alt=""
              className="h-11 w-11 shrink-0 rounded-xl object-cover object-top"
              draggable={false}
            />
            <span className="truncate font-display text-3xl leading-none text-ink">Citrus-Dala</span>
          </Link>

          <div className="flex shrink-0 items-center gap-2">
            {/* Public/Admin switch — Messy only (the sole admin) */}
            {isAdmin ? (
              isAdminView ? (
                <button
                  onClick={() => {
                    setPreviewPublic(true);
                    navigate("/");
                  }}
                  className="whitespace-nowrap rounded-full border-2 border-ink/25 px-3 py-1.5 text-xs font-semibold text-ink-soft transition-colors hover:border-ink hover:text-ink"
                >
                  Go To Public
                </button>
              ) : (
                <button
                  onClick={() => {
                    setPreviewPublic(false);
                    navigate("/admin");
                  }}
                  className="whitespace-nowrap rounded-full border-2 border-citrus/50 bg-citrus/10 px-3 py-1.5 text-xs font-semibold text-citrus-deep transition-colors hover:border-citrus"
                >
                  Go To Admin
                </button>
              )
            ) : null}

            <button
              onClick={() => setProfileOpen(true)}
              className="flex items-center gap-1.5 rounded-full border-2 border-ink/15 bg-paper-deep py-1 pl-1 pr-2.5 text-sm font-semibold text-ink-soft transition-colors hover:border-ink/30 hover:text-ink"
              aria-haspopup="dialog"
              aria-label="Your profile"
            >
              <Avatar person={user} size={28} bordered={false} />
              <span className="hidden max-w-[6.5rem] truncate sm:inline">{user.handle}</span>
            </button>
          </div>
        </div>
      </header>

      {profileOpen ? <ProfileSheet onClose={() => setProfileOpen(false)} /> : null}
      <PwaInstallPrompt />
    </>
  );
}
